import { render, staticRenderFns } from "./filterField.vue?vue&type=template&id=4f1defa2&scoped=true"
import script from "./filterField.vue?vue&type=script&lang=js"
export * from "./filterField.vue?vue&type=script&lang=js"
import style0 from "./filterField.vue?vue&type=style&index=0&id=4f1defa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1defa2",
  null
  
)

export default component.exports